import { createAction } from '../../utils/reduxUtils';
import { ITourSummary, TourCode } from '../../models';
import { IAsyncError } from '../../common/AsyncError';
import { ITourStatistics } from '../../models/TourStatistics';

const fetchPlayedTours = {
  request: createAction('@my_tours/FETCH_PLAYED_TOURS_REQUEST')<void>,
  success: createAction('@my_tours/FETCH_PLAYED_TOURS_SUCCESS')<Record<string, ITourSummary | null>>,
  failure: createAction('@my_tours/FETCH_PLAYED_TOURS_FAILURE')<IAsyncError>,
  cancel: createAction('@my_tours/FETCH_PLAYED_TOURS_CANCEL')<void>,
};

const fetchCreatedTours = {
  request: createAction('@my_tours/FETCH_CREATED_TOURS_REQUEST')<void>,
  success: createAction('@my_tours/FETCH_CREATED_TOURS_SUCCESS')<ITourSummary[]>,
  failure: createAction('@my_tours/FETCH_CREATED_TOURS_FAILURE')<IAsyncError>,
  cancel: createAction('@my_tours/FETCH_CREATED_TOURS_CANCEL')<void>,
};

const fetchStatistics = {
  request: createAction('@my_tours/FETCH_STATISTICS_REQUEST')<TourCode>,
  success: createAction('@my_tours/FETCH_STATISTICS_SUCCESS')<ITourStatistics>,
  failure: createAction('@my_tours/FETCH_STATISTICS_FAILURE')<IAsyncError>,
  cancel: createAction('@my_tours/FETCH_STATISTICS_CANCEL')<void>,
};

const actions = {
  fetchPlayedTours,
  fetchCreatedTours,
  fetchStatistics,
};

export default actions;
